import Link from '@/components/Link';

export default function EventPhotoGallery({
  event,
  uri,
}) {
  return (
    <div className="rounded-2xl shadow-xl bg-gray-900 p-6 flex flex-col space-y-6">
      <div className="flex flex-col space-y-2">
        <h3 className="text-gray-400 uppercase tracking-wide text-sm">
          Galería de fotos
        </h3>
        <h2 className="text-white font-semibold text-xl">
          Visualiza las instantáneas tomadas durante la realización del evento
        </h2>
      </div>
      <Link href={`${uri}/fotos`} className="bg-gray-700 rounded-xl p-4 flex items-center space-x-4 transform transition ease-in-out duration-300 hover:-translate-y-1 hover:bg-gray-600 focus:outline-none">
        <div className="w-10 h-10 rounded-full bg-green-600 text-white flex items-center justify-center">
          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4 5a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0011.172 3H8.828a2 2 0 00-1.414.586L6.293 4.707A1 1 0 015.586 5H4zm6 9a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="flex-1">
          <h4 className="text-left text-base font-medium text-white leading-normal">
            {event}
          </h4>
        </div>
      </Link>
    </div>
  );
}
